var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-wrapper"},[_c('div',{staticClass:"calculator"},[_c('CalculatorHeading',{attrs:{"step":_vm.step}}),_c('SelectInput',{attrs:{"question":_vm.$t('home-type.question'),"selections":[
        {
          image: require('@/assets/house.svg'),
          name: _vm.$t('home-type.house'),
          value: 'house'
        },
        {
          image: require('@/assets/apartment.svg'),
          name: _vm.$t('home-type.apartment'),
          value: 'apartment'
        }
      ],"selected-value":_vm.homeType,"clicked-callback":_vm.onSelect}}),_c('a',{staticClass:"back-btn",on:{"click":function($event){_vm.$router.push(_vm.getPrevStepUrl(_vm.step, _vm.$i18n.locale))}}},[_vm._v(_vm._s(_vm.$t('back')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }